/* eslint-disable no-param-reassign */
const compString = (a, b, forceSpaceLast = true) => {
  if (!((typeof a === 'string') && (typeof b === 'string'))) {
    return 0;
  }
  a = a.toLowerCase();
  b = b.toLowerCase();
  if (a === b) return 0;
  if (forceSpaceLast && a === '') return 1;
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
};

export default compString;
